/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EmailVerificationRequiredResponse {
  email_verification_required?: boolean;
  email: string;
  pending_authentication_token?: string | null;
  organization_id?: string | null;
  message?: string;
}
